exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stores {\n  width: 100%;\n}\n.stores-page {\n  width: 100%;\n  height: 92vh;\n  display: flex;\n  flex-direction: column;\n}\n.stores-left-side {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.create-store {\n  border-radius: 0 !important;\n}\n.country-panel {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  color: #a7a8aa;\n  font-size: 22px;\n  font-weight: 700;\n}\n.country-panel__edit {\n  display: flex;\n  align-items: center;\n  width: 25%;\n  justify-content: space-between;\n}\n.modal-remove-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.ant-modal-footer > div {\n  display: flex;\n  justify-content: space-between;\n}\n.stores-divider {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 28px;\n  text-transform: uppercase;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Stores/containers/Stores.less
// module id = 1012
// module chunks = 0